import { memo } from 'react';
import { AreaStack } from '@visx/shape';
import { keyBy } from 'lodash';

import { BrushPreviewGroupProps } from './brush-preview.model';

const AreaStackPreview = memo(function AreaStackPreviewBase<T extends {}>({
    groupKey,
    data,
    group,
    xScale,
    xAccessor,
    yScale,
}: BrushPreviewGroupProps<T>) {
    const keys = group.series.map(s => s.column);
    const columns = keyBy(group.series, 'column');
    const getColor = (key: string) => columns?.[key]?.color ?? '#eee';
    const domain = yScale.domain();

    const offset = domain[0] < 0 && domain[1] > 0 ? 'diverging' : 'none';

    return (
        <AreaStack
            keys={keys}
            data={data}
            x={d => xScale(xAccessor(d.data)) ?? 0}
            y0={d => yScale(d[0]) ?? 0}
            y1={d => yScale(d[1]) ?? 0}
            offset={offset}
        >
            {({ stacks, path }) => {
                return (
                    <>
                        {stacks.map(stack => {
                            return (
                                <path
                                    key={`${groupKey}-path-${group.id}-${stack.key}`}
                                    d={path(stack) || ''}
                                    strokeWidth={0}
                                    fill={getColor(stack.key)}
                                    opacity={0.65}
                                />
                            );
                        })}
                    </>
                );
            }}
        </AreaStack>
    );
});

export { AreaStackPreview };
